import { root } from 'postcss';

const styles = {
    root: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        tabs: {
            root: {
                width: '100%',
            },
        },
    },
    editor: {
        container: {
            border: '1px solid #e5e7eb',
            borderRadius: '0.375rem',
            padding: '1rem',
            width: '100%',
        },
        editorWrapper: {
            flex: 1,
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            height: '16rem',
            padding: '0.5rem',
            cursor: 'text',
            overflowY: 'auto', // Add vertical scrolling
            overflowX: 'hidden', // Prevent horizontal scrolling
        },
        button: {
            padding: '0.5rem 1rem',
            backgroundColor: '#3b82f6',
            color: '#ffffff',
            borderRadius: '0.375rem',
            border: 'none',
            cursor: 'pointer',
        },
        buttonContainer: {
            marginTop: '0.5rem',
            display: 'flex',
            gap: '0.5rem',
        },
        fileInput: {
            cursor: 'pointer',
        },
        toolbar: {
            display: 'flex',
            gap: '0.5rem',
            marginBottom: '0.5rem',
        },
        toolbarButton: {
            padding: '0.25rem 0.5rem',
            backgroundColor: '#f3f4f6',
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            cursor: 'pointer',
        },
        activeToolbarButton: {
            backgroundColor: '#3b82f6',
            color: '#ffffff',
        },
        editorContainer: {
            display: 'flex',
            gap: '1rem',
        },
        controlsPane: {
            flex: '0 0 200px',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
        },
        media: {
            maxWidth: '100%',
            height: 'auto',
        },
        toolbarTop: {
            display: 'flex',
            gap: '0.5rem',
            marginBottom: '1rem',
        },
        controlsPaneRight: {
            flex: '0 0 200px',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            marginLeft: '1rem',
        },
    },
};

export default styles;
